import { WorkflowSelectService } from '@flowgram.ai/free-layout-editor';
import { getRegisteredTeamFlowContext } from './teamFlowContextRegistry';
import { isTeamFlowCanvasReadonly } from './isTeamFlowCanvasReadonly';
import { useTeamFlowClipperStore } from '../store/useTeamFlowClipperStore';

/**
 * 将分享态 / mini 时间轴 / 全屏剪辑弹窗状态同步到 playground readonly，并在剪辑器占用画布时清空选区。
 */
export function syncTeamFlowCanvasReadonly(): void {
  const ctx = getRegisteredTeamFlowContext();
  if (!ctx) return;

  const readonly = isTeamFlowCanvasReadonly();
  ctx.playground.config.readonly = readonly;

  const { fullscreenOpen, visible } = useTeamFlowClipperStore.getState();
  if (!visible && !fullscreenOpen) return;

  const selectService = ctx.get(WorkflowSelectService);
  if (selectService.selection.length > 0) {
    selectService.selection = [];
  }
}
